module.exports = __webpack_public_path__ + "static/media/shutdown.855356d4.png";